<template>
  <div class="viewer-loading">
    <div class="spinner" aria-hidden="true"></div>
    <h2>Preparing slide viewer...</h2>
    <p>Loading visualization modules</p>
  </div>
</template>

<script>
export default {
  name: 'viewer-loading'
};
</script>

<style scoped>
.viewer-loading {
  min-height: 45vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.6rem;
  color: #2f2f2f;
}

.spinner {
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  border: 0.25rem solid #d7dbe0;
  border-top-color: #3b82f6;
  animation: spin 900ms linear infinite;
}

h2 {
  margin: 0;
  font-size: 0.95rem;
  letter-spacing: 0.06rem;
  text-transform: uppercase;
}

p {
  margin: 0;
  font-size: 0.85rem;
  color: #6b7280;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
